import type {
  FranchiseTeacherListItem,
  TeacherAttentionItem,
  TeacherAttentionTone,
} from '@/services/franchiseTeacherService'

/**
 * Attention conditions are calculated by the Stage 0 server read model.
 * Keep this module presentation-only so SQL/RPC and React cannot drift.
 */
export type TeacherInlineAttention = TeacherAttentionItem

export function getTeacherInlineAttention(teacher: FranchiseTeacherListItem): TeacherInlineAttention[] {
  if (teacher.status === 'dismissed') return []
  return teacher.attentionItems
}

export function teacherAttentionClass(tone: TeacherAttentionTone): string {
  if (tone === 'error') return 'border-error/30 bg-error/5 text-error'
  if (tone === 'warning') return 'border-amber-300 bg-amber-50 text-amber-800'
  return 'border-border bg-muted/50 text-muted-foreground'
}
